// moduleSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../services/AxiosInstance";

// Create an async thunk to fetch module data
export const fetchmoduleData = createAsyncThunk(
  "module/fetchmoduleData",
  async () => {
    try {
      const response = await axiosInstance.get("admin/module/view");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const moduleSlice = createSlice({
  name: "module",
  initialState: {
    data: [],
    moduleCount: 0,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchmoduleData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchmoduleData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.data = action.payload;
        state.moduleCount = action.payload.length;
      })
      .addCase(fetchmoduleData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export default moduleSlice.reducer;
